/**
 * Dispara uma vibração sutil, se suportado e permitido pelo usuário.
 * @param pattern A pattern of vibration and pause timings. E.g., [10] for a short buzz.
 */
export function triggerHaptic(pattern: VibratePattern = 10) {
  if (typeof window !== 'undefined' && window.navigator && window.navigator.vibrate) {
    try {
      window.navigator.vibrate(pattern);
    } catch (error) {
      console.warn('Haptic feedback failed.', error);
    }
  }
}
